import React, { useRef } from "react";
import { Box, Stack, Typography, keyframes } from "@mui/material";
import { motion } from "framer-motion";
import DesktopTeamComponent from "../Section7/DesktopTeamComponent";

import img1 from "../ourTeam/img/aanad sir.jpg";
import img2 from "../ourTeam/img/sezal sir.jpg";
import img3 from "../ourTeam/img/pitamber.jpg";
import img4 from "../ourTeam/img/ravindr.jpg";
import img5 from "../ourTeam/img/amit.jpg";
import img6 from "../ourTeam/img/kanchan.jpg";
import img7 from "../ourTeam/img/neha.jpg";
import img8 from "../ourTeam/img/shreya tiwari.jpg";
import img9 from "../ourTeam/img/Rojalin.jpeg";
import img10 from "../ourTeam/img/Lucky.jpg";
import img11 from "../ourTeam/img/Shyamli.jpg";
import ourTeamIcon from "./img/team1.png";
import twitterIcon from "./img/twitter.png";
import linkedinIcon from "./img/linkedin.png";
import whatsappIcon from "./img/whatsapp.png";
import instagramIcon from "./img/instagram.png";

// Fade-in animation consistent with Section10A
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const OurTeam = () => {
  const scrollRef = useRef(null);

  const testimonials = [
    {
      image: img1,
      name: "Shailendra Anand",
      position: "(Founder)",
      feedback:
        "As Founder, spearheading the design of scalable systems to streamline customer data management, enabling high lead conversion and sustained client relationships.",
      social: {
        linkedin: linkedinIcon,
        twitter: twitterIcon,
        whatsapp: whatsappIcon,
        instagram: instagramIcon,
      },
    },
    {
      image: img2,
      name: "Sazal Malhotra",
      position: "(Co-Founder)",
      feedback:
        "As Co-Founder, driving the vision and development of AI-powered no-code chatbot solutions to transform customer engagement and accelerate business growth.",
      social: {
        linkedin: linkedinIcon,
        twitter: twitterIcon,
        whatsapp: whatsappIcon,
        instagram: instagramIcon,
      },
    },
    {
      image: img3,
      name: "Pitamber Sarway",
      position: "(Fullstack Developer)",
      feedback:
        "Engineering end-to-end web solutions with seamless frontend, backend, and API integration to strengthen brand trust and maximize user engagement.",
      social: {
        linkedin: linkedinIcon,
        twitter: twitterIcon,
        whatsapp: whatsappIcon,
        instagram: instagramIcon,
      },
    },
    {
      image: img4,
      name: "Ravindra Pasvan",
      position: "(Frontend Developer)",
      feedback:
        "Designing responsive user interfaces and integrating backend functionality to deliver seamless digital experiences and measurable business impact.",
      social: {
        linkedin: linkedinIcon,
        twitter: twitterIcon,
        whatsapp: whatsappIcon,
        instagram: instagramIcon,
      },
    },
    {
      image: img5,
      name: "Amit Banjare",
      position: "(Fullstack Developer)",
      feedback:
        "Developing robust fullstack applications with a strong focus on secure backend architecture, API integration, and compliant data storage.",
      social: {
        linkedin: linkedinIcon,
        twitter: twitterIcon,
        whatsapp: whatsappIcon,
        instagram: instagramIcon,
      },
    },
    {
      image: img9,
      name: "Rojalin Behera",
      position: "(Frontend Developer)",
      feedback:
        "Creating dynamic user interfaces and integrating backend functionalities to scale customer engagement via broadcast and retargeting.",
      social: {
        linkedin: linkedinIcon,
        twitter: twitterIcon,
        whatsapp: whatsappIcon,
        instagram: instagramIcon,
      },
    },
    {
      image: img10,
      name: "Lekheshwar Das",
      position: "(Fullstack Developer)",
      feedback:
        "Developing robust frontend and backend systems with efficient API handling to enable large-scale broadcasts and precise customer retargeting.",
      social: {
        linkedin: linkedinIcon,
        twitter: twitterIcon,
        whatsapp: whatsappIcon,
        instagram: instagramIcon,
      },
    },
    {
      image: img7,
      name: "Neha Nand",
      position: "(Graphics Designer)",
      feedback:
        "Designing impactful visuals and creatives that enhance brand communication, streamline customer interaction, and elevate business presence across platforms.",
      social: {
        linkedin: linkedinIcon,
        twitter: twitterIcon,
        whatsapp: whatsappIcon,
        instagram: instagramIcon,
      },
    },
    {
      image: img6,
      name: "Kanchan Adil",
      position: "(Business Analyst)",
      feedback:
        "Analyzing data-driven strategies to maximize customer reach through broadcasting and boost conversions with targeted retargeting insights.",
      social: {
        linkedin: linkedinIcon,
        twitter: twitterIcon,
        whatsapp: whatsappIcon,
        instagram: instagramIcon,
      },
    },
    {
      image: img11,
      name: "Shyamli Rao",
      position: "(Marketing Specialist)",
      feedback:
        "Executing high-impact marketing campaigns on WhatsApp to drive engagement, boost reach, and deliver measurable results through targeted strategies.",
      social: {
        linkedin: linkedinIcon,
        twitter: twitterIcon,
        whatsapp: whatsappIcon,
        instagram: instagramIcon,
      },
    },
  ];

  return (
    <Box
      component="section"
      aria-label="Our Team - Vertex Suite"
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        boxSizing: "border-box",
        backgroundColor: "#E6F1FB",
        position: "relative",
        overflow: "hidden",
        ":before": {
          content: '""',
          position: "absolute",
          width: "300px",
          height: "300px",
          background: "#054E91",
          borderRadius: "50%",
          top: "-100px",
          right: "-100px",
          filter: "blur(120px)",
          opacity: 0.3,
          zIndex: 0,
        },
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        style={{ width: "100%" }}
      >
        <Stack
          id="our_team"
          component="article"
          sx={{
            maxWidth: { xs: "100%", sm: "90%", md: "1280px" },
            py: { xs: 2, sm: 3, md: 3, lg: 3.5 }, 
            px: { xs: 2, sm: 3, md: 4, lg: 6 },
            mx: "auto",
            fontFamily: "'Roboto', sans-serif",
            position: "relative",
            zIndex: 1,
            animation: `${fadeIn} 1.2s ease-in`,
          }}
        >
          {/* Header */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
            mb={{ xs: 1.5, sm: 2, md: 1.5, lg: 2 }}
            mt={{ xs: 0, sm: 0, md: 3, lg: 3 }}
          >
            <Box
              sx={{
                width: "6px",
                height: { xs: "22px", sm: "36px", md: "30px" },
                backgroundColor: "#054E91",
                borderTopRightRadius: "6px",
                borderBottomRightRadius: "6px",
                mr: 2,
              }}
            />
            <Typography
              variant="h4"
              component="h2"
              sx={{
                fontSize: { xs: "22px", sm: "28px", md: "34px" },
                color: "#054E91",
                fontFamily: "'Roboto', sans-serif",
                fontWeight: 600,
                letterSpacing: "0.5px",
                textAlign: "left",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              Our Team
              <img
                src={ourTeamIcon}
                alt="Team Icon"
                style={{ width: "35px", height: "35px", objectFit: "contain" }}
              />
            </Typography>
          </Stack>

          {/* Desktop Text */}
          <Typography
            sx={{
              fontSize: { xs: "15px", sm: "17px", md: "20px" },
              lineHeight: { xs: 1.5, sm: 1.8, md: 1.3 },
              fontFamily: "'Roboto', sans-serif",
              color: "text.secondary",
              letterSpacing: "0.3px",
              display: { xs: "none", sm: "block" },
              mb: { xs: 2, sm: 2, md: 6, lg: 6 },
            }}
          >
            We are a dynamic team of visionary developers, creative designers,
            data-driven analysts, and strategic marketers. Together, we
            transform ambitious ideas into innovative, scalable digital
            solutions that create real-world impact, accelerate growth, and
            shape the future of technology.
          </Typography>

          {/* Mobile Text */}
          <Typography
            sx={{
              fontSize: { xs: "15px", sm: "17px" },
              lineHeight: { xs: 1.5, sm: 1.8 },
              fontFamily: "'Roboto', sans-serif",
              color: "text.secondary",
              letterSpacing: "0.3px",
              display: { xs: "block", sm: "none" },
              mb: { xs: 2, sm: 2 },
            }}
          >
            A visionary team of developers, designers, analysts, and marketers
            building smart digital solutions for a better tomorrow.
          </Typography>

          <DesktopTeamComponent cardData={testimonials} />
        </Stack>
      </motion.div>
    </Box>
  );
};

export default OurTeam;
